// Copyright (c) 2016 Deere & Company

import productDetails from './product-details';

export default {
    productDetails
};



// WEBPACK FOOTER //
// ./src/product/details/reducers/index.js